'use strict';

angular.module('mandaeApp')
  .filter('notEmpty', function($filter, $sce) {
    return function(input) {
      if(input && input.replace(/\s/g, '') !== "") {
        return input.replace(/\s/g, '');
      }
      return null;
    };

  });
